export enum FecThirdPartyFilter {
  All = 'all',
  Clients = 'client',
  Suppliers = 'supplier',
}
